import { RadioGroup } from '@headlessui/react';
import { useHistory } from 'react-router';
import { useQuery } from 'utils/useQuery';

export const CategorySelector = () => {
  const query = useQuery();
  const history = useHistory();

  const category = query.get('category') || 'overall';

  const categories = [
    'overall',
    'acquisition',
    'activation',
    'retention',
    'churn',
  ];

  function handleChange(category: string) {
    query.set('category', category);

    // remove timeseries metric to reset to default
    query.delete('timeseries_metric');

    history.push({
      search: query.toString(),
    });
  }

  return (
    <div className="flex items-center justify-between px-6 py-4 mt-10 border divide-x rounded-2xl bg-segments-gray-F8">
      {/* <div className="flex items-center space-x-1">
          <SearchIcon className="w-5 h-5" />
          <input
            type="text"
            placeholder="Coming soon..."
            className="bg-transparent border-none"
          />
        </div> */}
      <RadioGroup value={category} onChange={handleChange}>
        <div className="flex items-center space-x-4">
          {categories.map((category) => (
            <RadioGroup.Option value={category} key={category}>
              {({ checked }) => (
                <span
                  className={`px-6 py-3 inline-block rounded-full bg-segments-gray text-segments-13px capitalize cursor-pointer ${
                    checked && 'bg-segments-accent-color-1 text-white'
                  }`}
                >
                  {category}
                </span>
              )}
            </RadioGroup.Option>
          ))}
        </div>
      </RadioGroup>
    </div>
  );
};
